__webpack_require__.p = "https://gamma.pi-ule-checklist.lab126.amazon.dev/";